const DEFAULT_PORTAL_APPLY_URL = 'http://localhost:8081'

export const portalApplyUrl = (process.env.PORTAL_APPLY_URL || DEFAULT_PORTAL_APPLY_URL).replace(/\/$/, '')

export function buildPortalApplyUrl (path = '', query = {}) {
  const normalizedPath = !path ? '' : (path.startsWith('/') ? path : `/${path}`)
  const url = new URL(`${portalApplyUrl}${normalizedPath}`)

  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return
    }
    url.searchParams.set(key, String(value))
  })

  return url.toString()
}



// WEBPACK FOOTER //
// ./src/utils/portal.js